import {Form, Label} from "reactstrap";
import React, {useCallback, useState} from "react";
import {AsyncTypeahead, Highlighter} from 'react-bootstrap-typeahead';
import 'react-bootstrap-typeahead/css/Typeahead.css';
import {useRouter} from "next/router";
import {FilterSelection} from "../../../types/filterSelection";

const SEARCH_URI = 'https://api.cottagecentre.nl/autocomplete';

const groupBy = function (xs, key) {
    return xs.reduce(function (rv, x) {
        (rv[x[key]] = rv[x[key]] || []).push(x);
        return rv;
    }, {});
};

interface SearchBoxProps {
    onKeyDown?: () => void
}

const SearchBox = ({ onKeyDown }: SearchBoxProps) => {
    const router = useRouter();
    const searchSelection: FilterSelection = FilterSelection.fromUrlParams(router);
    const [searchFocus, setSearchFocus] = React.useState(false)
    const onFocus = () => setSearchFocus(!searchFocus)
    const [isLoading, setIsLoading] = useState(false);
    const [options, setOptions] = useState([]);
    const ref = React.createRef();

    const handleSearch = useCallback((query) => {
        fetch(`${SEARCH_URI}/${query}`)
            .then((resp) => resp.json())
            .then((items) => {
                setOptions(items);
            });
    }, []);

    return (
        <Form id="mobile_search" className="form-inline d-sm-flex mobile-main-search">
            <div
                className={`input-label-absolute input-label-absolute-left input-reset input-expand w-100 ${
                    searchFocus ? "focus" : ""
                }`}
            >
                <Label for="search_search" className="label-absolute">
                    <i className="fa fa-search"></i>
                    <span className="sr-only">Wat zoekt u?</span>
                </Label>
                {/*<Typeahead*/}
                {/*    id="search_search"*/}
                {/*    onChange={(selected) => {*/}
                {/*        console.log(selected)*/}
                {/*    }}*/}
                {/*    options={["test", "test2"]}*/}
                {/*    size='small'*/}
                {/*    placeholder="Huiscode, trefwoord ..."*/}
                {/*    aria-label="Search"*/}
                {/*/>*/}

                <AsyncTypeahead
                    id="rendering-example"
                    useCache={false}
                    delay={150}
                    defaultInputValue={searchSelection.query}
                    highlightOnlyResult
                    emptyLabel="Geen suggesties..."
                    promptText="Typ uw zoekopdracht"
                    clearButton
                    onSearch={handleSearch}
                    isLoading={isLoading}
                    searchText="Zoeken..."
                    // renderMenu={(results, menuProps, state) => {
                    //     const categories = groupBy(results, 'category');
                    //     console.log(categories);
                    //
                    //     return <Menu {...menuProps}>
                    //         {Object.keys(categories).sort().map(category =>
                    //             <span key={category}>
                    //             <Menu.Header key={category}>{category}</Menu.Header>
                    //                 {categories[category].map((result, index) => (
                    //                     <MenuItem key={index} option={result} position={index}>
                    //                         <Highlighter search={state.text}>
                    //                             {result.name}
                    //                         </Highlighter>,
                    //                         <div>
                    //                             <small>
                    //                                 {category}
                    //                             </small>
                    //                         </div>
                    //                     </MenuItem>
                    //                 ))}
                    //             </span>
                    //         )}
                    //     </Menu>
                    // }}
                    renderMenuItemChildren={(option, {text}, index) => (
                        <>
                            <Highlighter search={text}>
                                {option.name}
                            </Highlighter>
                            <div>
                                <small>
                                    {option.category}
                                    {" "}
                                    {option.text && `in ${option.text}`}
                                </small>
                            </div>
                        </>
                    )}
                    labelKey="name"
                    options={options}
                    placeholder="Huiscode, trefwoord ..."
                    ref={ref}
                    onChange={(selected) => {
                        if (!selected[0]) {
                            return;
                        }

                        if (onKeyDown) {
                            onKeyDown();
                        }

                        if (selected[0].slug) {
                            router.push({
                                pathname: `/vakantiehuizen/${selected[0].slug}`,
                            })
                        }

                        if (selected[0].seoId) {
                            router.push({
                                pathname: `/vakantiehuis/${selected[0].seoId}`,
                            })
                        }
                    }}
                    onKeyDown={event => {
                        if (event.keyCode === 13) {
                            event.preventDefault();
                            if (onKeyDown) {
                                onKeyDown();
                            }
                            router.push({
                                pathname: `/vakantiehuis`,
                                query: {
                                    zoekopdracht: event.target.value,
                                }
                            })
                        }
                    }}
                    size="small"
                >
                    {/*<button onClick={() => ref.current.clear()}>*/}
                    {/*    X*/}
                    {/*</button>*/}
                </AsyncTypeahead>

                {/*<Input*/}
                {/*    id="search_search"*/}
                {/*    placeholder="Huiscode, trefwoord ..."*/}
                {/*    aria-label="Search"*/}
                {/*    bsSize="sm"*/}
                {/*    className="border-0 shadow-0 bg-gray-200"*/}
                {/*    onFocus={onFocus}*/}
                {/*    onBlur={() => setTimeout(() => onFocus(), 333)}*/}
                {/*/>*/}
                <button type="reset" className="btn btn-sm btn-reset">
                    <i className="fas fa-times"></i>
                </button>
            </div>
        </Form>
    )
}

export default SearchBox;
